import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import TextArea from '../../../content/components/TextArea/TextArea';
import HorizontalFormControl from '../../../../common/components/HorizontalFormControl/HorizontalFormControl';
import startCase from '../../../../helpers/socratesLodash/startCase';

export default class Sections extends Component {
  render() {
    const { template, input } = this.props;
    return (
      <>
        {Object.keys(template.attributes.sections).map((templateSectionKey) => {
          const isTextArea =
            template.attributes.sections[templateSectionKey].fieldtype === 'textarea';
          return (
            <div key={templateSectionKey}>
              {isTextArea && (
                <Row>
                  <Col sm={12}>
                    <ControlLabel>{startCase(templateSectionKey)}</ControlLabel>
                  </Col>
                </Row>
              )}
              <Row>
                <Col sm={12}>
                  <Field
                    key={templateSectionKey}
                    name={`${input.name}.${templateSectionKey}`}
                    type={templateSectionKey}
                    label={startCase(templateSectionKey)}
                    labelSize={3}
                    component={isTextArea ? TextArea : HorizontalFormControl}
                  />
                </Col>
              </Row>
            </div>
          );
        })}
      </>
    );
  }
}
